


















































import Vue from 'vue'
import {State} from 'vuex-class'
import Component from 'vue-class-component'
import Widget from '@/modules/widget/model/Widget'
import {Watch} from 'vue-property-decorator'
import {Colors, notify} from '@/modules/core/notification'
import {VueGridLayoutWidget} from '@/modules/widget/support'
import WidgetCatalog from '@/modules/widget/components/WidgetCatalog.vue'

/**
 * Tablero de widgets
 *
 * Muestra al usuario una grilla de pequeños componentes de utilidad que puede ser configurada
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        WidgetCatalog,
    },
})
export default class WidgetBoard extends Vue {
    /**
     * Disposición actual mostrada al usuario
     */
    @State(state => state.widget.layout)
    public layout: Widget[];

    public virtualLayout: any[] = [];

    public locked = true;
    public reloading = false;

    @Watch('layout')
    public onLayoutChange () {
        this.virtualLayout = this.layout.map(w => ({
            x: w.positionX,
            y: w.positionY,
            h: w.columnHeight,
            w: w.columnWidth,
            i: w.tempId,
            component: w.type.component,
            id: w.id,
            minW: w.type.minimumColumnWidth,
            minH: w.type.minimumColumnHeight,
            resizable: w.type.resizable,
        }));
    }

    /**
     * Recarga la grilla de widgets solicitando a la aplicación volver a carga
     * la lista de estos
     */
    public async reloadLayout () {
        this.reloading = true;
        await this.$store.dispatch('widget/loadWidgetLayout');

        notify('El tablero de widgets se ha recargado correctamente', Colors.Error, {
            notShowInCenter: true,
        });

        this.reloading = false;
    }

    public async updateLayout (layout: VueGridLayoutWidget[]) {
        await this.$store.dispatch('widget/updateWidgetLayout', layout)
    }

    public async created () {
        await this.$store.dispatch('widget/loadWidgetLayout')
    }
}
